import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

import { FormBuilderConfig } from '../types/form-builder.types'

export const createBuilderValidators = (config: FormBuilderConfig[]) => {
  const { t } = useTranslation()

  const options = [...config]
    .filter((confgItem) => confgItem.required)
    .reduce((acc: Record<string, any>, configItem) => {
      acc[configItem.id] = Yup.string().required(`${configItem.label} ${t('common.required')}`)

      return acc
    }, {})

  return Yup.object().shape(options)
}
